import { render, staticRenderFns } from "./EventEditorsTable.vue?vue&type=template&id=907b4360&scoped=true"
import script from "./EventEditorsTable.vue?vue&type=script&lang=ts"
export * from "./EventEditorsTable.vue?vue&type=script&lang=ts"
import style0 from "./EventEditorsTable.vue?vue&type=style&index=0&id=907b4360&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "907b4360",
  null
  
)

export default component.exports